import { render } from "./construction-2.vue?vue&type=template&id=c340c42e&scoped=true"
import script from "./construction-2.vue?vue&type=script&lang=js"
export * from "./construction-2.vue?vue&type=script&lang=js"

import "./construction-2.vue?vue&type=style&index=0&id=c340c42e&scoped=true&lang=css"

import exportComponent from "D:\\Web\\hkjt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c340c42e"]])

export default __exports__